const stateOptions = [
	{
		key: 1,
		text: "Con Error",
		value: "error",
	},
	{
		key: 2,
		text: "Confirmadas",
		value: "confirmadas",
	},
	{
		key: 3,
		text: "Enviadas",
		value: "enviadas",
	},
	// {
	// 	key: 4,
	// 	text: "Sin Enviar",
	// 	value: "sinenviar",
	// },
];

export default stateOptions;
